import { render, staticRenderFns } from "./TaskRibbon.vue?vue&type=template&id=60aeeae5&scoped=true"
import script from "./TaskRibbon.vue?vue&type=script&lang=js"
export * from "./TaskRibbon.vue?vue&type=script&lang=js"
import style0 from "./TaskRibbon.vue?vue&type=style&index=0&id=60aeeae5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60aeeae5",
  null
  
)

export default component.exports